<script setup lang="ts">
import { useSlots } from 'vue'

withDefaults(defineProps<{ label: string; value: string | number | boolean; width?: string }>(), { width: '100%' })
defineSlots<{ content(): void }>()
const slots = useSlots()
</script>

<template>
  <el-radio-button :label="label" :value="value" class="radio-button">
    <slot v-if="slots.content" name="content" />
  </el-radio-button>
</template>

<style scoped lang="scss">
.radio-button {
  width: v-bind(width);
}
:deep(.el-radio-button__inner.el-radio-button__inner) {
  --el-border-radius-base: 40px;
  height: 40px;
  width: 100%;
  padding: 10px 24px;

  border-radius: 40px;
  box-shadow: none;

  border: 1px solid var(--secondary-12);
  background: var(--secondary-12);
  color: var(--primary);

  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
}
.radio-button :deep(.el-radio-button__inner.el-radio-button__inner) {
  border-radius: 40px;
}
:deep(.el-radio-button__original-radio:checked + .el-radio-button__inner.el-radio-button__inner) {
  border: 1px solid var(--primary);
  background: var(--surface);
  color: var(--primary);
  box-shadow: none;
}
:deep(.el-radio-button.is-active) {
  .el-radio-button__original-radio:not(:disabled) + .el-radio-button__inner {
    background: red;
  }
}
</style>
